import { Injectable } from "@angular/core";
import { MatIconRegistry } from "@angular/material/icon";
import { DomSanitizer } from "@angular/platform-browser";

@Injectable()
export class IconLoaderService {
  constructor(
    private registry: MatIconRegistry,
    private domSanitizer: DomSanitizer
  ) {}

  registerIcons(list) {
    list.forEach(({ name, path }) => {
      this.registry.addSvgIcon(
        name,
        this.domSanitizer.bypassSecurityTrustResourceUrl(path)
      );
    });
  }
}
